import { iconPerAlertSeverityAndStatus } from "./riskIcons";

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const winningAlertLogic = (alarms, alarmShown) => {
  return alarmShown;
};

const pointStructure = (
  alarms,
  beneficiary,
  highestAlarmStatus,
  iconUrlParam,
  highestAlarmSeverity,
  highestAlarmDescription
) => {
  const firstName = beneficiary.firstname || "";
  const lastName = beneficiary.lastname || "";
  const fullName = `${firstName} ${lastName}`.trim() || "N/A";
  const addressValue = [
    beneficiary.address?.street,
    beneficiary.address?.number,
    beneficiary.address?.postalcode,
  ]
    .filter(Boolean)
    .join(" ")
    .trim();

  return {
    genderId: beneficiary.genderId,
    beneficiaryId: beneficiary.id,
    latitude: beneficiary.address?.latitude,
    longitude: beneficiary.address?.longitude,
    name: fullName,
    address: addressValue || "N/A",
    age: beneficiary.age,
    phone: beneficiary.telephone || "N/A",
    iconUrl: iconUrlParam,
    alarms: alarms,
    highestAlarmSeverity: highestAlarmSeverity,
    highestAlarmDescription: highestAlarmDescription,
    highestAlarmStatus: highestAlarmStatus,
    alarmRiskScore:
      highestAlarmSeverity === "High"
        ? 3
        : highestAlarmSeverity === "Middle"
        ? 2
        : highestAlarmSeverity === "Middle"
        ? 1
        : 0,
  };
};


export const createPoints = (beneficiaries) => {
  let alarms;

  return beneficiaries.map((beneficiary) => {
    if (beneficiary.alarms?.length > 0) {
      alarms = beneficiary.alarms;
    } else {
      alarms = [];
    }
    return pointStructure(
      alarms,
      beneficiary,
      beneficiary.highestAlarmStatus,
      iconPerAlertSeverityAndStatus(
        beneficiary.highestAlarmStatus,
        beneficiary.highestAlarmSeverity
      ),
      beneficiary.highestAlarmSeverity,
      beneficiary.highestAlarmDescription
    );
  });
};
